const _maxMultiplier = 8, _coordPrecision = 5, _base = 64, _coord2s = (coord) => {
    const positiveCoord = coord + 180;
    let s = '', currentTotal = positiveCoord / _maxMultiplier;
    for (let i = 0; i < _coordPrecision; ++i) {
        const digitNum = Math.floor(currentTotal), digit = _n2s[digitNum];
        s += digit;
        currentTotal = (currentTotal - digitNum) * _base;
    }
    return s;
}, _n2s = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
    'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
    'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X',
    'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f',
    'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
    'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
    'w', 'x', 'y', 'z', '0', '1', '2', '3',
    '4', '5', '6', '7', '8', '9', '-', '_',
], _s2coord = (coordStr) => {
    let positiveCoord = 0, multiplier = _maxMultiplier;
    for (const currentChar of coordStr) {
        const charNum = _s2n[currentChar];
        positiveCoord += charNum * multiplier;
        multiplier /= _base;
    }
    return positiveCoord - 180;
}, _s2n = (() => {
    const s2n = {};
    _n2s.forEach((character, index) => {
        s2n[character] = index;
    });
    return s2n;
})();
export { _coord2s, _s2coord, _coordPrecision, };
